/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReferralDocumentExport202ResponseData
 */
export interface CreateReferralDocumentExport202ResponseData {
    /**
     * 
     */
    export_id: string;
}

/**
 * Check if a given object implements the CreateReferralDocumentExport202ResponseData interface.
 */
export function instanceOfCreateReferralDocumentExport202ResponseData(value: object): value is CreateReferralDocumentExport202ResponseData {
    if (!('export_id' in value) || value['export_id'] === undefined) return false;
    return true;
}

export function CreateReferralDocumentExport202ResponseDataFromJSON(json: any): CreateReferralDocumentExport202ResponseData {
    return CreateReferralDocumentExport202ResponseDataFromJSONTyped(json, false);
}

export function CreateReferralDocumentExport202ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReferralDocumentExport202ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'export_id': json['export_id'],
    };
}

export function CreateReferralDocumentExport202ResponseDataToJSON(json: any): CreateReferralDocumentExport202ResponseData {
    return CreateReferralDocumentExport202ResponseDataToJSONTyped(json, false);
}

export function CreateReferralDocumentExport202ResponseDataToJSONTyped(value?: CreateReferralDocumentExport202ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'export_id': value['export_id'],
    };
}

